import { Pipe, type PipeTransform } from "@angular/core";

export interface TextPart {
  text: string;
  hit: boolean;
}

// Splits text into plain and matched parts (case-insensitive) so the template can wrap matches in <mark>.
@Pipe({ name: "highlightWords" })
export class HighlightWordsPipe implements PipeTransform {
  transform(text: string | null | undefined, words: string[]): TextPart[] {
    if (!text) return [];
    const lower = text.toLowerCase();
    const hit = new Array<boolean>(text.length).fill(false);
    for (const word of words) {
      const needle = word.toLowerCase();
      for (let at = lower.indexOf(needle); at !== -1; at = lower.indexOf(needle, at + 1)) {
        hit.fill(true, at, at + needle.length);
      }
    }
    const parts: TextPart[] = [];
    for (let i = 0; i < text.length; i++) {
      const last = parts.at(-1);
      if (last && last.hit === hit[i]) last.text += text[i];
      else parts.push({ text: text[i], hit: hit[i] });
    }
    return parts;
  }
}
